"use client";
import cn from "classnames";
import { usePathname } from "next/navigation";
import ActiveAnchor from "@/components/common/ActiveAnchor";
import Layout from "@/components/common/Layout";
import List from "@/components/common/List";
import type { SingleLineMenu } from "../../types";
import { getPageNavBarItems } from "../../utils/getPageNavBarItems";
import { getSingleLineActiveGroupItem } from "../../utils/getSingleLineActiveGroupItem";
import ss from "../ClassicSingleLineMenu/ClassicSingleLineMenu.module.scss";
import s from "./ClassicFixedSingleLineNav.module.scss";

export interface ClassicFixedSingleLineNavProps {
  menuItems: SingleLineMenu;
  fullWidth?: boolean;
}

export default function ClassicFixedSingleLineNav(
  props: ClassicFixedSingleLineNavProps,
) {
  const { menuItems, fullWidth } = props;

  const pathname = usePathname();
  const activeGroupItem = getSingleLineActiveGroupItem(pathname, menuItems);

  if (!activeGroupItem) return null;

  return (
    <nav className={s.nav}>
      <Layout fluid={fullWidth} containerOnly>
        <List
          items={getPageNavBarItems(activeGroupItem.subMenuItems)}
          renderItem={(item) => (
            <ActiveAnchor
              href={item.url}
              openInNewTab={item.openInNewTab}
              className={cn(ss.anchor, s.anchor)}
            >
              {item.label}
            </ActiveAnchor>
          )}
        />
      </Layout>
    </nav>
  );
}
